export enum EInvoiceListFilter {
  Pending = 'PENDING',
  Blocked = 'BLOCKED',
  Approved = 'APPROVED',
  Unblocked = 'UNBLOCKED',
}
